import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/@babel/runtime/regenerator";
import { _ as _slicedToArray, b as _asyncToGenerator, c as _createForOfIteratorHelper } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React, { useState, useEffect } from 'react';

var TableOfContents = function TableOfContents(props) {
  var contentMetaData = props.contentMetaData || {};
  props.contentDataData || {};
  props.integratorData || {};
  var navResultData = props.navResultData || {};

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      pageParentDataArray = _useState2[0],
      setPageParentDataArray = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      pageParentAncestorsDataArray = _useState4[0],
      setPageParentAncestorsDataArray = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      tocChildren = _useState6[0],
      setTocChildren = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      navResultDataOrdered = _useState8[0],
      setNavResultDataOrdered = _useState8[1];

  var isParentTitle = props.isParentTitle || 'In this section';
  var isChildTitle = props.isChildTitle || 'Quick Links';

  function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function procesItem(_x, _x2) {
    return _procesItem.apply(this, arguments);
  }

  function _procesItem() {
    _procesItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, newArrayOrder) {
      var newChildrenOrder;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!item.children) {
                _context4.next = 8;
                break;
              }

              _context4.next = 3;
              return item.children.sort(dynamicSort('order'));

            case 3:
              newChildrenOrder = _context4.sent;
              item.children = newChildrenOrder;
              newArrayOrder.push(item);
              _context4.next = 9;
              break;

            case 8:
              newArrayOrder.push(item);

            case 9:
              return _context4.abrupt("return", item);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _procesItem.apply(this, arguments);
  }

  function processArray(_x3) {
    return _processArray.apply(this, arguments);
  }

  function _processArray() {
    _processArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(array) {
      var newArrayOrder, _iterator, _step, item;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              newArrayOrder = [];
              _iterator = _createForOfIteratorHelper(array);
              _context5.prev = 2;

              _iterator.s();

            case 4:
              if ((_step = _iterator.n()).done) {
                _context5.next = 10;
                break;
              }

              item = _step.value;
              _context5.next = 8;
              return procesItem(item, newArrayOrder);

            case 8:
              _context5.next = 4;
              break;

            case 10:
              _context5.next = 15;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](2);

              _iterator.e(_context5.t0);

            case 15:
              _context5.prev = 15;

              _iterator.f();

              return _context5.finish(15);

            case 18:
              _context5.next = 20;
              return newArrayOrder.sort(dynamicSort('order'));

            case 20:
              newArrayOrder = _context5.sent;
              return _context5.abrupt("return", newArrayOrder);

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 12, 15, 18]]);
    }));
    return _processArray.apply(this, arguments);
  }

  var returnParentAncestorsArray = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, ancestors) {
      var ancestorsArray;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!id) {
                _context.next = 9;
                break;
              }

              if (!(navResultData && navResultData.menu && navResultData.menu.length > 0)) {
                _context.next = 6;
                break;
              }

              ancestorsArray = ancestors.filter(function (item) {
                return item.id === id;
              });
              return _context.abrupt("return", ancestorsArray);

            case 6:
              return _context.abrupt("return", []);

            case 7:
              _context.next = 10;
              break;

            case 9:
              return _context.abrupt("return", []);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function returnParentAncestorsArray(_x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();

  var returnParentArray = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, ancestors) {
      var parentArrayData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!id) {
                _context2.next = 9;
                break;
              }

              if (!(navResultData && navResultData.menu && navResultData.menu.length > 0)) {
                _context2.next = 6;
                break;
              }

              parentArrayData = navResultData.menu.filter(function (item) {
                return item.id === id;
              });
              return _context2.abrupt("return", parentArrayData);

            case 6:
              return _context2.abrupt("return", []);

            case 7:
              _context2.next = 10;
              break;

            case 9:
              return _context2.abrupt("return", []);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function returnParentArray(_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    function buildNavArrays() {
      return _buildNavArrays.apply(this, arguments);
    }

    function _buildNavArrays() {
      _buildNavArrays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var newPageParentDataArray, sortedNewPageParentDataArray, newPageParentAncestorsDataArray, sortedNewPageParentAncestorsDataArray, newChildrenArray, newNavResultData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(contentMetaData && contentMetaData.parent && contentMetaData.parent.id)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 3;
                return returnParentArray(contentMetaData.parent.id, contentMetaData.ancestors);

              case 3:
                newPageParentDataArray = _context3.sent;

                if (!newPageParentDataArray) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 7;
                return processArray(newPageParentDataArray);

              case 7:
                sortedNewPageParentDataArray = _context3.sent;
                sortedNewPageParentDataArray = sortedNewPageParentDataArray[0];
                setPageParentDataArray(sortedNewPageParentDataArray);

              case 10:
                if (!(contentMetaData && contentMetaData.parent && contentMetaData.parent.id && contentMetaData.ancestors)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 13;
                return returnParentAncestorsArray(contentMetaData.parent.id, contentMetaData.ancestors);

              case 13:
                newPageParentAncestorsDataArray = _context3.sent;

                if (!newPageParentAncestorsDataArray) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return processArray(newPageParentAncestorsDataArray);

              case 17:
                sortedNewPageParentAncestorsDataArray = _context3.sent;
                sortedNewPageParentAncestorsDataArray = sortedNewPageParentAncestorsDataArray[0];
                setPageParentAncestorsDataArray(sortedNewPageParentAncestorsDataArray);

              case 20:
                if (!(contentMetaData.children && contentMetaData.children.length > 0)) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 23;
                return processArray(contentMetaData.children);

              case 23:
                newChildrenArray = _context3.sent;
                setTocChildren(newChildrenArray);

              case 25:
                if (!(navResultData && navResultData.menu && navResultData.menu.length > 0)) {
                  _context3.next = 30;
                  break;
                }

                _context3.next = 28;
                return processArray(navResultData.menu);

              case 28:
                newNavResultData = _context3.sent;
                setNavResultDataOrdered(newNavResultData);

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _buildNavArrays.apply(this, arguments);
    }

    buildNavArrays();
  }, []);
  var Html = props.html || /*#__PURE__*/React.createElement("div", {
    className: "table_of_contents"
  }, tocChildren.children && tocChildren.length > 0 ? /*#__PURE__*/React.createElement("strong", null, isParentTitle) : !contentMetaData.parent ? /*#__PURE__*/React.createElement("strong", null, isChildTitle) : /*#__PURE__*/React.createElement("strong", null, isParentTitle), /*#__PURE__*/React.createElement("ul", null, tocChildren.children && tocChildren.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, console.debug('sidebar contentMetaData', contentMetaData), contentMetaData.title && contentMetaData.isPublished === true && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: contentMetaData.slug && contentMetaData.slug === contentMetaData.slug ? 'active parent-nav-item' : 'parent-nav-item',
    href: contentMetaData.parentSlug ? contentMetaData.parentSlug + contentMetaData.slug : contentMetaData.slug
  }, contentMetaData.title))), tocChildren && tocChildren.length > 0 ? tocChildren.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, console.debug('sidebar tocChildren', item), item.title && item.isPublished === true && /*#__PURE__*/React.createElement("li", {
      className: "toc_child_link",
      key: i
    }, /*#__PURE__*/React.createElement("a", {
      key: i,
      className: contentMetaData.slug && contentMetaData.slug === item.slug ? 'active child-nav-item' : 'child-nav-item',
      href: item.parentSlug ? item.parentSlug + item.slug : item.slug
    }, item.title)));
  }) : pageParentDataArray && pageParentDataArray.children && pageParentDataArray.children.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, console.debug('sidebar pageParentDataArray', pageParentDataArray), pageParentDataArray && pageParentDataArray.title && pageParentDataArray.isPublished === true && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: contentMetaData.slug && contentMetaData.slug === pageParentDataArray.slug ? 'active parent-nav-item' : 'parent-nav-item',
    href: pageParentDataArray.parentSlug ? pageParentDataArray.parentSlug + pageParentDataArray.slug : pageParentDataArray.slug
  }, pageParentDataArray.title)), pageParentDataArray && pageParentDataArray.children && pageParentDataArray.children.length > 0 && pageParentDataArray.children.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, item.title && item.isPublished === true && /*#__PURE__*/React.createElement("li", {
      className: "toc_parent_link",
      key: i
    }, /*#__PURE__*/React.createElement("a", {
      key: i,
      className: contentMetaData.slug && contentMetaData.slug === item.slug ? 'active child-nav-item' : 'child-nav-item',
      href: item.parentSlug ? item.parentSlug + item.slug : item.slug
    }, item.title)));
  })) : pageParentAncestorsDataArray && pageParentAncestorsDataArray.children && pageParentAncestorsDataArray.children.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, console.debug('pageParentAncestorsDataArray', pageParentAncestorsDataArray), pageParentAncestorsDataArray && pageParentAncestorsDataArray.title && pageParentAncestorsDataArray.isPublished === true && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: contentMetaData.slug && contentMetaData.slug === pageParentAncestorsDataArray.slug ? 'active parent-nav-item' : 'parent-nav-item',
    href: pageParentAncestorsDataArray.parentSlug ? pageParentAncestorsDataArray.parentSlug + pageParentAncestorsDataArray.slug : pageParentAncestorsDataArray.slug
  }, pageParentAncestorsDataArray.title)), pageParentAncestorsDataArray && pageParentAncestorsDataArray.children && pageParentAncestorsDataArray.children.length > 0 && pageParentAncestorsDataArray.children.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, item.title && item.isPublished === true && /*#__PURE__*/React.createElement("li", {
      className: "toc_parent_link",
      key: i
    }, /*#__PURE__*/React.createElement("a", {
      key: i,
      className: contentMetaData.slug && contentMetaData.slug === item.slug ? 'active child-nav-item' : 'child-nav-item',
      href: item.parentSlug ? item.parentSlug + item.slug : item.slug
    }, item.title)));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, navResultDataOrdered && navResultDataOrdered.length > 0 && navResultDataOrdered.map(function (item, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, console.debug('sidebar navResultDataOrdered', navResultDataOrdered), item.title && item.isPublished === true && /*#__PURE__*/React.createElement("li", {
      className: "toc_nav_link",
      key: i
    }, /*#__PURE__*/React.createElement("a", {
      className: contentMetaData.slug && contentMetaData.slug === item.slug ? 'active child-nav-item' : 'child-nav-item',
      href: item.parentSlug ? item.parentSlug + item.slug : item.slug
    }, item.title)));
  }))));
  return Html;
};

export default TableOfContents;